import { Link } from "react-router-dom";
import { CalendarPlus } from "lucide-react";
import { MenuOrSheet } from "@/components/ActionSheet";
import { calendarItems } from "@/lib/calendarLinks";

const MON = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];
const LABEL = { escritura: "Próxima escritura", cpcv: "Próximo CPCV" };

// «O meu dia»: só a próxima escritura ou CPCV, com atalho para o calendário.
export function NextEventCard({ e }) {
  if (!e) {
    return (
      <section className="rounded-[12px] px-3.5 py-3 border border-slate-100 bg-white" data-testid="next-event-card" data-soon="0">
        <div className="text-[11px] font-bold tracking-[0.12em] uppercase text-slate-500">Próxima escritura</div>
        <div className="text-[15px] text-slate-500" data-testid="next-event-none">Sem escrituras nem CPCV marcados</div>
      </section>
    );
  }
  const soon = e.days <= 14;
  const [, m, d] = e.date.split("-");
  const when = e.days === 0 ? "Hoje" : e.days === 1 ? "Amanhã" : `${Number(d)} ${MON[Number(m) - 1]}`;
  const items = calendarItems({ uid: `${e.kind}-${e.id}`, title: `${e.kind === "cpcv" ? "CPCV" : "Escritura"} · ${e.address}`, date: e.date, time: e.time, place: e.place, prefix: "next-event" });
  return (
    <section className={`rounded-[12px] px-3.5 py-3 flex items-center gap-3 ${soon ? "navy-bg text-white" : "border border-slate-100 bg-white"}`} data-testid="next-event-card" data-soon={soon ? "1" : "0"}>
      <div className="flex-1 min-w-0">
        <div className={`text-[11px] font-bold tracking-[0.12em] uppercase ${soon ? "text-white/70" : "text-slate-500"}`} data-testid="next-event-label">{LABEL[e.kind]}</div>
        <Link to={`/processo/${e.id}`} className="block text-[15px] font-semibold truncate hover:underline" data-testid="next-event-line">
          {[when, e.address, e.time].filter(Boolean).join(" · ")}
        </Link>
      </div>
      <MenuOrSheet title="Adicionar ao calendário" testid="next-event-menu" align="end" items={items}
        trigger={<button type="button" title="Adicionar ao calendário" aria-label="Adicionar ao calendário" className={`shrink-0 inline-flex items-center gap-1.5 h-9 px-3 rounded-[10px] text-sm font-semibold transition-colors ${soon ? "bg-white navy-text hover:bg-white/90" : "border border-slate-300 bg-white navy-text hover:bg-slate-50"}`} data-testid="next-event-calendar">
          <CalendarPlus size={15} /><span className="hidden sm:inline">Adicionar ao calendário</span>
        </button>} />
    </section>
  );
}
